'use strict';

var _objectSpread = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var errCode = require('err-code');

var UnixFS = require('ipfs-unixfs');

var persist = require('../../utils/persist');

var _require = require('ipld-dag-pb'),
    DAGNode = _require.DAGNode,
    DAGLink = _require.DAGLink;

var all = require('it-all');

var parallelBatch = require('it-parallel-batch');

var mh = require('multihashing-async').multihash;

var dagBuilders = {
  flat: require('./flat'),
  balanced: require('./balanced'),
  trickle: require('./trickle')
};

function buildFileBatch(_x, _x2, _x3, _x4) {
  return _buildFileBatch.apply(this, arguments);
}

function _buildFileBatch() {
  _buildFileBatch = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file, source, block, options) {
    var count, previous, bufferImporter, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, entry;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            count = -1;

            if (typeof options.bufferImporter === 'function') {
              bufferImporter = options.bufferImporter;
            } else {
              bufferImporter = require('./buffer-importer');
            }

            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context.prev = 4;
            _iterator = _asyncIterator(parallelBatch(bufferImporter(file, source, block, options), options.blockWriteConcurrency));

          case 6:
            _context.next = 8;
            return _awaitAsyncGenerator(_iterator.next());

          case 8:
            _step = _context.sent;
            _iteratorNormalCompletion = _step.done;
            _context.next = 12;
            return _awaitAsyncGenerator(_step.value);

          case 12:
            _value = _context.sent;

            if (_iteratorNormalCompletion) {
              _context.next = 30;
              break;
            }

            entry = _value;
            count++;

            if (!(count === 0)) {
              _context.next = 21;
              break;
            }

            previous = entry;
            return _context.abrupt("continue", 27);

          case 21:
            if (!(count === 1)) {
              _context.next = 25;
              break;
            }

            _context.next = 24;
            return previous;

          case 24:
            previous = null;

          case 25:
            _context.next = 27;
            return entry;

          case 27:
            _iteratorNormalCompletion = true;
            _context.next = 6;
            break;

          case 30:
            _context.next = 36;
            break;

          case 32:
            _context.prev = 32;
            _context.t0 = _context["catch"](4);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 36:
            _context.prev = 36;
            _context.prev = 37;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context.next = 41;
              break;
            }

            _context.next = 41;
            return _awaitAsyncGenerator(_iterator.return());

          case 41:
            _context.prev = 41;

            if (!_didIteratorError) {
              _context.next = 44;
              break;
            }

            throw _iteratorError;

          case 44:
            return _context.finish(41);

          case 45:
            return _context.finish(36);

          case 46:
            if (!previous) {
              _context.next = 50;
              break;
            }

            previous.single = true;
            _context.next = 50;
            return previous;

          case 50:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 32, 36, 46], [37,, 41, 45]]);
  }));
  return _buildFileBatch.apply(this, arguments);
}

var reduce = function reduce(file, block, options) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(leaves) {
      var leaf, _yield$block$get, _buffer, multihash, f, links, node, buffer, cid;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(leaves.length === 1 && leaves[0].single && options.reduceSingleLeafToSelf)) {
                _context2.next = 15;
                break;
              }

              leaf = leaves[0];

              if (!(leaf.cid.codec === 'raw' && (file.mtime !== undefined || file.mode !== undefined))) {
                _context2.next = 14;
                break;
              }

              _context2.next = 5;
              return block.get(leaf.cid, options);

            case 5:
              _yield$block$get = _context2.sent;
              _buffer = _yield$block$get.data;
              leaf.unixfs = new UnixFS({
                type: 'file',
                mtime: file.mtime,
                mode: file.mode,
                data: _buffer
              });
              multihash = mh.decode(leaf.cid.multihash);
              _buffer = new DAGNode(leaf.unixfs.marshal()).serialize();
              _context2.next = 12;
              return persist(_buffer, block, _objectSpread(_objectSpread({}, options), {}, {
                codec: 'dag-pb',
                hashAlg: multihash.name,
                cidVersion: options.cidVersion
              }));

            case 12:
              leaf.cid = _context2.sent;
              leaf.size = _buffer.length;

            case 14:
              return _context2.abrupt("return", {
                cid: leaf.cid,
                path: file.path,
                unixfs: leaf.unixfs,
                size: leaf.size
              });

            case 15:
              // create a parent node and add all the leaves
              f = new UnixFS({
                type: 'file',
                mtime: file.mtime,
                mode: file.mode
              });
              links = leaves.filter(function (leaf) {
                if (leaf.cid.codec === 'raw' && leaf.size) {
                  return true;
                }

                if (!leaf.unixfs.data && leaf.unixfs.fileSize()) {
                  return true;
                }

                return Boolean(leaf.unixfs.data.length);
              }).map(function (leaf) {
                if (leaf.cid.codec === 'raw') {
                  // node is a leaf buffer
                  f.addBlockSize(leaf.size);
                  return new DAGLink(leaf.name, leaf.size, leaf.cid);
                }

                if (!leaf.unixfs.data) {
                  // node is an intermediate node
                  f.addBlockSize(leaf.unixfs.fileSize());
                } else {
                  // node is a unixfs 'file' leaf node
                  f.addBlockSize(leaf.unixfs.data.length);
                }

                return new DAGLink(leaf.name, leaf.size, leaf.cid);
              });
              node = new DAGNode(f.marshal(), links);
              buffer = node.serialize();
              _context2.next = 21;
              return persist(buffer, block, options);

            case 21:
              cid = _context2.sent;
              return _context2.abrupt("return", {
                cid: cid,
                path: file.path,
                unixfs: f,
                size: buffer.length + node.Links.reduce(function (acc, curr) {
                  return acc + curr.Tsize;
                }, 0)
              });

            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x5) {
      return _ref.apply(this, arguments);
    };
  }();
};

var fileBuilder = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(file, source, block, options) {
    var dagBuilder, roots;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            dagBuilder = dagBuilders[options.strategy];

            if (dagBuilder) {
              _context3.next = 3;
              break;
            }

            throw errCode(new Error("Unknown importer build strategy name: ".concat(options.strategy)), 'ERR_BAD_STRATEGY');

          case 3:
            _context3.next = 5;
            return all(dagBuilder(buildFileBatch(file, source, block, options), reduce(file, block, options), options));

          case 5:
            roots = _context3.sent;

            if (!(roots.length > 1)) {
              _context3.next = 8;
              break;
            }

            throw errCode(new Error('expected a maximum of 1 roots and got ' + roots.length), 'ETOOMANYROOTS');

          case 8:
            return _context3.abrupt("return", roots[0]);

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fileBuilder(_x6, _x7, _x8, _x9) {
    return _ref2.apply(this, arguments);
  };
}();

module.exports = fileBuilder;